<div class="col-md-12"
    style="box-shadow: 3px 3px 33px 6px #7500C0; height: 35vw;background: linear-gradient(141deg, #fafafa 20%, #fafafa 65%);">
    <div class="row">
        <div class="col-lg-12">
            <h3 class="page-header" style="color: #000000;"><i class="fa fa-laptop"></i> Gateway Wise Dashboard</h3>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-8 col-md-12">
            <div class="panel panel-default" style="margin-top:-2%;">
                <div class="col-sm-12">
                    <div class="col-sm-2 formDivCaptions">
                        <label style="color:black;font-weight:bold">Device Type</label>
                    </div>
                    <div class="col-sm-4">
                        <div class="row">
                            <div class="col-sm-12 formDivTextBoxDropdownControls" style="margin-left:-8%;">
                                <label *ngFor="let DeviceType of DeviceTypeList">
                                    <input type="radio" id="radioDeviceTypeGateway_{{DeviceType.id}}" name="radioDeviceTypeGateway"
                                        value="{{DeviceType.name}}"
                                        (click)="DeviceTypeEventGateway()" /><label>&nbsp;{{DeviceType.name}}&nbsp;
                                    </label>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2 formDivCaptions">
                        <label style="color:black;font-weight:bold">Country</label>
                    </div>
                    <div class="col-sm-4" *ngIf="globalAdmin">
                        <div class="row">
                            <div class="col-sm-12 formDivTextBoxDropdownControls" style="margin-left:-8%;">
                                <select class="form-control col-sm-4" id="dlstCountry1" name="dlstCountry1"
                                    [(ngModel)]="dlstCountryModel" (change)="DeviceTypeEventGateway()">
                                    <option value="">&lt;--Select--&gt;</option>
                                    <option *ngFor="let C of Countries">{{C.Country}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4" *ngIf="regAdmin">
                        <div class="row">
                            <div class="col-sm-12 formDivTextBoxDropdownControls" style="margin-left:-8%;">
                                <label>{{Country}}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <br />

                <div *ngIf="showGatewayMainDashboard">
                    <div class="panel-body" style="height: 250px; overflow:scroll;margin-top:-2%;">
                        <table class="table bootstrap-datatable countries">
                            <thead>
                                <tr>
                                    <th style="color: #000000">
                                        <span class="tooltip">
                                            <img alt="" src="/assets/img/info2.jpg" class="img-circle"
                                                style="width: 10%; height: 6%; margin-bottom: -30px; margin-left: 75%;">
                                            <span class="tooltiptext"
                                                style="margin-bottom: -20px; margin-left: -62px; ">Gateways through
                                                which calls were routed.</span>
                                        </span>Gateway Name
                                    </th>
                                    <th style="color: #000000">
                                        <span class="tooltip">
                                            <img alt="" src="/assets/img/info2.jpg" class="img-circle"
                                                style="width: 10%; height: 6%; margin-bottom: -30px; margin-left: 50%;">
                                            <span class="tooltiptext"
                                                style="margin-bottom: -20px; margin-left: -115px; ">The facility from
                                                which calls were made.</span>
                                        </span>Facility
                                    </th>
                                    <th style="color: #000000">
                                        <span class="tooltip">
                                            <img alt="" src="/assets/img/info2.jpg" class="img-circle"
                                                style="width: 10%; height: 6%; margin-bottom: -30px; margin-left: 40%;">
                                            <span class="tooltiptext"
                                                style="margin-bottom: -20px; margin-left: -115px; ">The total no. of
                                                calls with respect to call types for the current month.</span>
                                        </span>Count
                                    </th>
                                    <th style="color: #000000">
                                        <span class="tooltip">
                                            <img alt="" src="/assets/img/info2.jpg" class="img-circle"
                                                style="width: 10%; height: 6%; margin-bottom: -30px; margin-left: 57%;">
                                            <span class="tooltiptext"
                                                style="margin-bottom: -20px; margin-left: -90px;">The total cost with
                                                respect to call types for the current month.</span>
                                        </span>Total Cost
                                    </th>

                                </tr>
                            </thead>
                            <tbody *ngFor="let data of successfulData.voiceAdminGatewayDashboard ">
                                <tr>
                                    <td>{{data.GatewayName}}</td>
                                    <td>{{data.Facility}}</td>
                                    <td>{{data.Count}}</td>
                                    <td>{{data.Cost}}</td>
                                </tr>
                                <tr></tr>
                            </tbody>

                            <tfoot>
                            </tfoot>
                        </table>
                    </div>

                </div>
                <div *ngIf="showMsgGatewayMainDashboard">
                    <label
                        style="color: #000000; font-weight: bold; font-size: 15px;margin-left: 10px;">{{ErrorMessage}}</label>
                </div>
            </div>
        </div>
        <div class="col-md-4" *ngIf="showGatewayMainDashboard">
            <div class="col-sm-12"
                style="font-family: Century; font-size: 14px;  border: 1px solid #7500C0 !important; border-image: none !important; height: 70%; overflow: hidden; box-shadow: -1px -1px 12px -1px #7500C0;margin-top:-2%;">
                <!-- <canvas style="margin-top: 10%; margin-left: 5%;" class=" chart chart-doughnut" chart-data="dataGatewayDashboard" chart-labels="labelsGatewayDashboard"
                    chart-options="optionsGatewayDashboard" legend="true" height="340"></canvas> -->
                <canvas style="margin-top: 0%; margin-left: 5%;" height="340" baseChart [data]="dataGatewayDashboard"
                    [labels]="labelsGatewayDashboard" [colors]="DoughnutColors" [chartType]="pieChartType"
                    [options]="optionsGatewayDashboard" [legend]="true"></canvas>
            </div>
        </div>
    </div>
</div>